import { useState } from "react";
import { useHistory } from "react-router-dom";
import useUrlState from "@ahooksjs/use-url-state";

import brands from "configs/brands";
import GenericHeader from "../../../components/GenericHeader/GenericHeader";
import GenericTable from "../../../components/GenericTable/GenericTable";

import Box from "@mui/material/Box";

import placeholderPic from "../../../assets/no_data_x.gif";
import { useApiHook } from "providers/ApiProvider";

const BrandsTableView = () => {
  const history = useHistory();

  const [selectedRows, setSelectedRows] = useState([]);
  const [queryParams, setQueryParams] = useUrlState({
    // q: undefined,
    page: 0,
    size: 10,
    // sortBy: "code",
    // sortDirection: "desc",
  });

  // const [searchQuery, setSearchQuery] = useState(
  //   localStorage.getItem("searchQuery") || ""
  // );

  // const permissionChecker = usePermissionChecker();

  const query = {
    // q: searchQuery ?? "",
    page: Number(queryParams.page) + 1,
    size: queryParams.size,
    // sortBy: queryParams.sortBy ?? "code",
    // sortDirection: queryParams.sortDirection ?? "desc",
  };

  const brandData = useApiHook("Brands", "getAllResources", { query });

  // const handleSearch = (value: string) => {
  //   localStorage.setItem("searchQuery", value);
  //   setSearchQuery(value);

  //   if (queryParams.q !== value) {
  //     setQueryParams({ q: value, page: 0 });
  //   } else {
  //     setQueryParams({ q: value });
  //   }
  // };

  // const deleteBrand = () => {
  //   if (!permissionChecker("delete-brand", true)) return;

  //   setLoading(true);

  //   brandsClient
  //     .deleteManyResource({ data: selectedRows })
  //     .then(() => fetchData())
  //     .finally(() => setLoading(false));
  // };

  const navigateToAddPage = () => {
    history.push(`brands/add`);
  };

  const rowTriggerAction = (row: any) => {
    history.push(`brands/${row?.code}`);
  };

  const handlePageChange = (e: any, value: any) => {
    setQueryParams({ page: value });
  };

  const handleRowsChange = (e: { target: { value: string } }) => {
    setQueryParams({ page: 0, size: parseInt(e.target.value) });
  };

  const handleRowSelectionChange = (data: any) => {
    setSelectedRows(data);
  };

  // const onColumnSort = (c: any) => {
  //   if (queryParams.sortBy === c) {
  //     setQueryParams((s) => ({
  //       sortDirection: s.sortDirection === "asc" ? "desc" : "asc",
  //     }));
  //   } else {
  //     setQueryParams({ sortBy: c, sortDirection: "asc" });
  //   }
  // };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        maxHeight: "100vh",
        overflow: "scroll",
      }}
    >
      <GenericHeader
        // onSearch={handleSearch}
        addResourceHandler={navigateToAddPage}
        // deleteResourceHandler={deleteBrand}
        selectedRows={selectedRows}
        model="customer"
      />
      <div className="p-4">
        <h2 className="mb-4">Brands</h2>
        <GenericTable
          showCheckbox={false}
          frontendPagination={true}
          list={brandData?.data?.data ? brandData.data.data : []}
          totalCount={brandData?.data?.data?.length || 0}
          onSelectedChange={handleRowSelectionChange}
          selectedRows={selectedRows}
          page={Number(queryParams.page)}
          loading={brandData.loading}
          rowsPerPage={Number(queryParams.size)}
          onRowsChange={handleRowsChange}
          onPageChange={handlePageChange}
          image={placeholderPic}
          tableConfig={brands}
          model="brand"
          passRow={rowTriggerAction}
          // columnSort={queryParams.sortBy}
          // columnSortDir={queryParams.sortDirection}
          // onColumnSort={onColumnSort}
        />
      </div>
    </Box>
  );
};

export default BrandsTableView;
